<app-generic [structure]="structure"></app-generic>